// "YYYY-MM-DD" of a date in the user's own time zone.
//
// Not d.toISOString().slice(0, 10): that converts to UTC first, so in India
// (UTC+5:30) "today" reads as yesterday until 5:30 AM, and a local midnight
// such as the first of the month always reads as the day before.
export const toLocalYmd = (d = new Date()) => {
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
};
